export default __webpack_public_path__ + "static/media/hero_1536.e0e5ed22.jpg";